export const cases = [
  {
    slug: "brass-pendants",
    tag: "Lighting · Moradabad",
    title: "12,000 brass pendants",
    spec: "4 ports · 0 rework · 18% cost saved",
    year: "2024",
    sector: "Lighting",
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/9kz3zlcu_4040B386-57D4-4009-9540-02894FD03167.png",
    client: "European retail group",
    sku: "12 SKUs",
    units: "12,000",
    leadTime: "11 weeks",
    brief:
      "A European specialist needed a brass pendant range that could ship to four ports simultaneously without rework. Existing supplier had failed twice on photometry.",
    approach:
      "We re-routed to a Moradabad partner with in-house electroplating, rebuilt the tech pack around three core profiles, and ran in-line photometry alongside AQL 2.5 inspection on every container.",
    outcome:
      "Twelve SKUs shipped across four ports with zero rework on landing. Material consolidation and a single lacquer line saved 18% against the original quote.",
    stats: [
      { num: 18, suffix: "%", lbl: "Cost saved" },
      { num: 0, lbl: "Rework on landing" },
      { num: 4, lbl: "Ports, same window" },
    ],
  },
  {
    slug: "dining-range",
    tag: "Furniture · Jodhpur",
    title: "A 40-SKU dining range",
    spec: "Sampled in 6 weeks · FSC sheesham",
    year: "2024",
    sector: "Furniture",
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/b844eelb_9C323BD6-C46B-4B29-8703-06684A96BCD0.png",
    client: "Independent home label",
    sku: "40 SKUs",
    units: "2,400",
    leadTime: "14 weeks",
    brief:
      "A new dining collection needed to land for catalogue, with FSC-certified sheesham and a tight sampling window before tradeshow.",
    approach:
      "Two Jodhpur workshops developed in parallel — one for solid tops, one for metal bases. Tech packs aligned, moisture-controlled storage, and a single QC lead across both.",
    outcome:
      "Forty SKUs sampled in six weeks and signed off without revision. Production shipped on the original tradeshow date.",
    stats: [
      { num: 40, lbl: "SKUs sampled" },
      { num: 6, suffix: "wk", lbl: "To sign-off" },
      { num: 100, suffix: "%", lbl: "FSC sheesham" },
    ],
  },
  {
    slug: "blue-pottery",
    tag: "Décor · Jaipur",
    title: "Blue-pottery, zero breakage",
    spec: "Re-engineered packing · 99.4% intact",
    year: "2023",
    sector: "Home décor",
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/4vshlb6w_2488C0C8-9F5F-49CB-B89B-957A4819DF61.png",
    client: "North American retailer",
    sku: "18 SKUs",
    units: "8,500",
    leadTime: "9 weeks",
    brief:
      "Persistent in-transit breakage on hand-painted Jaipur blue pottery was killing margin. Insurance was no longer covering the line.",
    approach:
      "Rebuilt packing from the inside out — moulded pulp inners, fluted dividers, drop-test certified to ISTA-3A. QC checkpoint at packing, not just at finish.",
    outcome:
      "99.4% intact on landing across two consecutive shipments. Insurance loadings dropped, line returned to margin.",
    stats: [
      { num: 99, suffix: "%", lbl: "Intact on landing" },
      { num: 3, suffix: "A", lbl: "ISTA pack tested" },
      { num: 2, lbl: "Shipments, same result" },
    ],
  },
  {
    slug: "hand-blown",
    tag: "Glass · Firozabad",
    title: "Hand-blown holiday line",
    spec: "3 seasons · AQL 2.5 · on time",
    year: "2023",
    sector: "Lighting",
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/zrja1grd_58C9B5C2-8860-492D-9420-5CE424B83120.png",
    client: "Seasonal homeware brand",
    sku: "24 SKUs",
    units: "30,000",
    leadTime: "16 weeks",
    brief:
      "A seasonal hand-blown glass line needed to deliver three years running without slipping ship dates. Hand-blown means tolerances vary.",
    approach:
      "Single Firozabad partner locked, golden-sample library kept on site, AQL 2.5 with photo evidence at three checkpoints. Pre-booked container capacity each season.",
    outcome:
      "Three seasons shipped on the planned week. Defect rate inside AQL on every audit.",
    stats: [
      { num: 3, lbl: "Seasons on time" },
      { num: 24, lbl: "SKUs maintained" },
      { num: 2.5, lbl: "AQL pass standard" },
    ],
  },
  {
    slug: "panipat-throws",
    tag: "Textile · Panipat",
    title: "Recycled-yarn throws, GRS-certified",
    spec: "GRS + GOTS · 12 colourways · 25,000 units",
    year: "2024",
    sector: "Textile",
    image:
      "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts/elm86mkp_210CB9A9-2E47-4A20-AB35-A1FC58714566.png",
    client: "European homeware retailer",
    sku: "12 colourways",
    units: "25,000",
    leadTime: "12 weeks",
    brief:
      "A European homeware retailer needed a soft-furnishing line in recycled yarn, certified to GRS and GOTS, with twelve colourways across throws and cushions for a single drop.",
    approach:
      "Single Panipat mill, GRS chain-of-custody verified, GOTS approval on the dyeing line, fibre-content lab testing on every colourway, and in-line inspection at weaving, dyeing and finishing stages.",
    outcome:
      "Twenty-five thousand units shipped on the planned date, certificates archived per SKU, zero claims on landing.",
    stats: [
      { num: 12, lbl: "Colourways" },
      { num: 25000, lbl: "Units shipped" },
      { num: 100, suffix: "%", lbl: "GRS + GOTS verified" },
    ],
  },
];

export const getCase = (slug) => cases.find((c) => c.slug === slug);
